const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'WdAutoCompleteOptGroup';
export default OptGroup;
